import { formieSymbol } from '~/layers/formie/formie-plugin';

export const getFormieField = (name) => {
    const formie = inject(formieSymbol);
    return formie.getField(name);
};
